import styled from 'styled-components';
import { Row } from '@simplywallst/ui-core';

export const LoadingOverlayWrapper = styled(Row)`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  color: ${({ theme }) => theme.color.white};
  z-index: 9999;
`;

export const LoadingTextWrapper = styled.p`
  margin-top: ${({ theme }) => theme.x4spacePx}px;
  font-size: ${({ theme }) => (theme.x2space - 0.4) * 10}px;
  max-width: 200px;
`;
